import styled from "styled-components";

export const ModalContent = styled.div`
  overflow: scroll;
  background-color: #fff;

  @media (min-width: 768px) {
    padding: 1rem 0;
  }
`;

export const PolicyTitle = styled.h1`
  text-align: center;
  margin: 1rem 0 2rem 0;
  color: #4181f8;
  font-size: 1.5rem;
`;

export const DivisionCheckbox = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;

  .message {
    @media(max-width: 360px) {
      width: 85%;
    }
  }

  button {
    outline: none;
    padding: .5rem 1rem;
    border: 0px;
    background-color: ${(props) => props.children[1].props.children.props.checked ? "#4181f8" : "#707070"};
    color: white;
    border-radius: 5px;

    @media(max-width: 770px) {
      margin: 1rem 0rem;
      z-index: 999;
    }
  }

  @media(max-width: 770px) {
    align-items: baseline;
    flex-direction: column;
    margin-top: -1rem;
    z-index: 999;
  }
`;

export const DocumentContainer = styled.div`

  @media(max-width: 770px) and (max-height: 845px) {
    height: 39.3rem;
  }
  
  @media(max-width: 770px) and (max-height: 825px) {
    height: 38.7rem;
  }
  
  @media(max-width: 770px) and (max-height: 810px) {
    height: 37.7rem;
  }
  
  @media(max-width: 770px) and (max-height: 790px) {
    height: 36.4rem;
  }

  @media(max-width: 770px) and (max-height: 765px) {
    height: 34.8rem;
  }
  
  @media(max-width: 770px) and (max-height: 750px) {
    height: 33.6rem;
  }
  
  @media(max-width: 770px) and (max-height: 730px) {
    height: 32.5rem;
  }
  
  @media(max-width: 770px) and (max-height: 710px) {
    height: 31.5rem;
  }
  
  @media(max-width: 770px) and (max-height: 690px) {
    height: 30.5rem;
  }

  @media(max-width: 770px) and (max-height: 670px) {
    height: 29.4rem;
  }

  @media(max-width: 770px) and (max-height: 650px) {
    height: 28.4rem;
  }

  @media(max-width: 770px) and (max-height: 630px) {
    height: 27.4rem;
  }

  @media(max-width: 770px) and (max-height: 610px) {
    height: 26rem;
  }

  @media(max-width: 770px) and (max-height: 600px) {
    height: 25rem;
  }
  
  @media(max-width: 770px) and (max-height: 580px) {
    height: 24rem;
  }

  @media(max-width: 770px) and (max-height: 570px) {
    height: 23rem;
  }

  @media(max-width: 770px) and (max-height: 560px) {
    height: 22rem;
  }

  @media(max-width: 430px) {
    width: 22rem;
  }

  @media(max-width: 390px) {
    width: 20rem;
  }

  @media(max-width: 380px) {
    width: 19rem;
  }

  @media(max-width: 370px) {
    width: 18rem;
  }

  @media(max-width: 350px) {
    width: 17.8rem;
  }
  
  @media(max-width: 770px) {
    overflow: scroll;
    margin: 0% 0% 10% 0%;
    
    ::-webkit-scrollbar {
      width: 8px !important;
      height: 8px !important;
    }

    /* Track */
    ::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3) !important;
      -webkit-border-radius: 10px !important;
      border-radius: 10px !important;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
      -webkit-border-radius: 10px !important;
      border-radius: 10px !important;
      background: #C1C1C1 !important; 
      -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.5) !important; 

    }
    ::-webkit-scrollbar-thumb:window-inactive {
      background: #C1C1C1 !important; 
    }

    .text-center {
      transform: translate(50px, 50px) !important;
      overflow: scroll !important;
    }
  }
`;